export const QueryParams = {
    RoomIdKey: "roomId",
    DiscussionIdKey: "discussionId",
    CommsIdKey: "commsId",
    IsAnnouncementsOpened: "announcements"
}